import { KAPLAYCtx } from "kaplay";
import { GAME_HEIGHT, GAME_WIDTH, SCENES } from "../constants";
import { GameOverStats } from "../types";
import { getHighScore, saveIfHighScore } from "../storage";
import { PALETTE, textStyle } from "../theme";
import { addPulsingButton } from "../ui/buttons";

const CENTER_X = GAME_WIDTH / 2;

export function registerGameOverScene(k: KAPLAYCtx): void {
    k.scene(SCENES.gameOver, (stats?: GameOverStats) => {
        const score = stats?.score ?? 0;
        const barriersPassed = stats?.barriersPassed ?? 0;
        const maxCombo = stats?.maxCombo ?? 1;

        const isNewBest = saveIfHighScore(score);
        // max() keeps this right even if storage is unavailable
        const bestScore = Math.max(score, getHighScore());

        k.add([k.rect(GAME_WIDTH, GAME_HEIGHT), k.pos(0, 0), k.color(18, 12, 16), k.z(-10)]);

        const hazardLine = k.add([k.rect(GAME_WIDTH, 12), k.pos(0, 80), k.color(255, 40, 80), k.opacity(1)]);
        hazardLine.onUpdate(() => {
            hazardLine.opacity = 0.6 + Math.sin(k.time() * 10) * 0.4;
        });

        k.add([k.text("VAPORIZED!", textStyle(46)), k.pos(CENTER_X, 170), k.anchor("center"), k.color(255, 60, 80)]);
        k.add([
            k.text("CONTACT WITH RAINBOW LASER", textStyle(14)),
            k.pos(CENTER_X, 215),
            k.anchor("center"),
            k.color(220, 120, 140),
        ]);

        // Score card
        k.add([
            k.rect(420, 240, { radius: 10 }),
            k.pos(CENTER_X, 370),
            k.anchor("center"),
            k.color(28, 20, 26),
            k.outline(2, k.rgb(80, 45, 60)),
        ]);

        if (isNewBest) {
            k.add([k.text("★ NEW HIGH SCORE! ★", textStyle(16)), k.pos(CENTER_X, 280), k.anchor("center"), k.color(...PALETTE.gold)]);
        }

        k.add([k.text("FINAL SCORE", textStyle(14)), k.pos(CENTER_X, 315), k.anchor("center"), k.color(180, 180, 190)]);
        k.add([k.text(score.toLocaleString(), textStyle(44)), k.pos(CENTER_X, 355), k.anchor("center"), k.color(...PALETTE.white)]);
        k.add([
            k.text(`BEST: ${bestScore.toLocaleString()}`, textStyle(15)),
            k.pos(CENTER_X, 405),
            k.anchor("center"),
            k.color(...PALETTE.gold),
        ]);
        k.add([
            k.text(`BARRIERS PASSED: ${barriersPassed}   MAX COMBO: x${maxCombo}`, textStyle(13)),
            k.pos(CENTER_X, 445),
            k.anchor("center"),
            k.color(160, 170, 190),
        ]);

        const restartGame = () => k.go(SCENES.game);
        const goToMenu = () => k.go(SCENES.start);

        addPulsingButton(k, { label: "PLAY AGAIN", y: 570, pulseAmount: 0.02, onPress: restartGame });

        const menuButton = k.add([
            k.rect(320, 56, { radius: 8 }),
            k.pos(CENTER_X, 660),
            k.anchor("center"),
            k.color(40, 45, 60),
            k.outline(2, k.rgb(100, 110, 135)),
            k.area(),
        ]);
        k.add([k.text("MAIN MENU", textStyle(18)), k.pos(CENTER_X, 660), k.anchor("center"), k.color(200, 210, 230)]);
        menuButton.onClick(goToMenu);

        k.onKeyPress(["space", "enter"], restartGame);
        k.onKeyPress("escape", goToMenu);
    });
}
